export const bootstrapFlexSettingsOptions = (value) => {
  let classInfix;
  if (value === '') {
    classInfix = '';
  } else {
    classInfix = `${value}-`;
  }
  return [
    { value: `d-${classInfix}flex`, label: `d-${classInfix}flex` },
    {
      value: `d-${classInfix}inline-flex`,
      label: `d-${classInfix}inline-flex`,
    },
    { value: `flex-${classInfix}row`, label: `flex-${classInfix}row` },
    {
      value: `flex-${classInfix}row-reverse`,
      label: `flex-${classInfix}row-reverse`,
    },
    { value: `flex-${classInfix}column`, label: `flex-${classInfix}column` },
    {
      value: `flex-${classInfix}column-reverse`,
      label: `flex-${classInfix}column-reverse`,
    },
    {
      value: `justify-content-${classInfix}start`,
      label: `justify-content-${classInfix}start`,
    },
    {
      value: `justify-content-${classInfix}end`,
      label: `justify-content-${classInfix}end`,
    },
    {
      value: `justify-content-${classInfix}center`,
      label: `justify-content-${classInfix}center`,
    },
    {
      value: `justify-content-${classInfix}between`,
      label: `justify-content-${classInfix}between`,
    },
    {
      value: `justify-content-${classInfix}around`,
      label: `justify-content-${classInfix}around`,
    },
    {
      value: `align-items-${classInfix}start`,
      label: `align-items-${classInfix}start`,
    },
    {
      value: `align-items-${classInfix}end`,
      label: `align-items-${classInfix}end`,
    },
    {
      value: `align-items-${classInfix}center`,
      label: `align-items-${classInfix}center`,
    },
    {
      value: `align-items-${classInfix}baseline`,
      label: `align-items-${classInfix}baseline`,
    },
    {
      value: `align-items-${classInfix}stretch`,
      label: `align-items-${classInfix}stretch`,
    },
    {
      value: `align-self-${classInfix}start`,
      label: `align-self-${classInfix}start`,
    },
    {
      value: `align-self-${classInfix}end`,
      label: `align-self-${classInfix}end`,
    },
    {
      value: `align-self-${classInfix}center`,
      label: `align-self-${classInfix}center`,
    },
    {
      value: `align-self-${classInfix}baseline`,
      label: `align-self-${classInfix}baseline`,
    },
    {
      value: `align-self-${classInfix}stretch`,
      label: `align-self-${classInfix}stretch`,
    },
    { value: `flex-${classInfix}fill`, label: `flex-${classInfix}fill` },
    {
      value: `flex-${classInfix}shrink-0`,
      label: `flex-${classInfix}shrink-0`,
    },
    {
      value: `flex-${classInfix}shrink-1`,
      label: `flex-${classInfix}shrink-1`,
    },
    { value: `flex-${classInfix}grow-0`, label: `flex-${classInfix}grow-0` },
    { value: `flex-${classInfix}grow-1`, label: `flex-${classInfix}grow-1` },
    { value: `flex-${classInfix}nowrap`, label: `flex-${classInfix}nowrap` },
    { value: `flex-${classInfix}wrap`, label: `flex-${classInfix}wrap` },
    {
      value: `flex-${classInfix}wrap-reverse`,
      label: `flex-${classInfix}wrap-reverse`,
    },
    {
      value: `align-content-${classInfix}start`,
      label: `align-content-${classInfix}start`,
    },
    {
      value: `align-content-${classInfix}end`,
      label: `align-content-${classInfix}end`,
    },
    {
      value: `align-content-${classInfix}center`,
      label: `align-content-${classInfix}center`,
    },
    {
      value: `align-content-${classInfix}around`,
      label: `align-content-${classInfix}around`,
    },
    {
      value: `align-content-${classInfix}stretch`,
      label: `align-content-${classInfix}stretch`,
    },
  ];
};

export const tailwindFlexSettingsOptions = (classInfix) => {
  return [
    { value: `${classInfix}:hidden`, label: `${classInfix}:hidden` },
    {
      value: `${classInfix}:block`,
      label: `${classInfix}:block`,
    },
  ];
};
